<template>
  <div>
    <div class="header">
      <div class="dhl">
        <div class="dhl1">
          <router-link to="/">
            <a href="#a1"
              ><img :src="fileServerUrl + 'assets/phamax/phaIcon.png'" alt=""
            /></a>
          </router-link>
        </div>
        <div class="dhl2">
          <div class="dropdown">
            <a href="http://www.huiyuexpo.com"
              ><span class="menu">{{ $t("organizer") }}</span></a
            >
          </div>
          <div class="dropdown">
            <router-link to="/">
              <a href="#a1"
                ><span
                  class="menu"
                  :class="{ 'menu-active': menuIndex == 1 }"
                  >{{ $t("home") }}</span
                ></a
              >
            </router-link>
          </div>

          <div class="dropdown">
            <router-link to="/About">
              <span
                class="menu"
                :class="{ 'menu-active': menuIndex == 2 }"
                style="cursor: pointer"
                >{{ $t("about") }}</span
              >
            </router-link>
          </div>

          <div class="dropdown">
            <router-link to="/jointype">
              <span
                class="menu"
                :class="{ 'menu-active': menuIndex == 3 }"
                style="cursor: pointer"
                >{{ $t("type") }}</span
              >
            </router-link>
          </div>
          <div class="dropdown">
            <router-link to="/aggenda">
              <span
                class="menu"
                :class="{ 'menu-active': menuIndex == 4 }"
                style="cursor: pointer"
                >{{ $t("agenda") }}</span
              >
            </router-link>
          </div>
          <div class="dropdown">
            <span
              class="menu"
              :class="{ 'menu-active': menuIndex == 5 }"
              style="cursor: pointer"
              >{{ $t("sponsor") }}</span
            >

            <div class="dropdown-content">
              <router-link to="/sponsor"
                ><p>{{ $t("why_sponsor") }}</p></router-link
              >

              <!-- 往届赞助商 -->
              <!-- <router-link to="/exibitions"
                ><p>{{ $t("sponsors_exhibitors") }}</p></router-link
              > -->
            </div>
          </div>

          <div class="dropdown">
            <router-link to="/mate">
              <span
                class="menu"
                :class="{ 'menu-active': menuIndex == 6 }"
                style="cursor: pointer"
                >{{ $t("partners") }}</span
              >
            </router-link>
          </div>

          <div class="iconEn" @click="changelang">
            <!-- 中英文 -->
            <!-- <i
              class="iconfont icon-tansuob"
              style="
                margin-right: 5px;
                color: rgb(31, 163, 209);
                font-size: 0.8em;
                cursor: pointer;
              "
            ></i> -->

            <!-- <router-link to="/enhomeview">
              <i
                class="iconfont icon-tansuob"
                style="
                  margin-right: 5px;
                  color: rgb(31, 163, 209);
                  font-size: 0.8em;
                "
              ></i>
              <span class="menu" :class="{ 'menu-active': menuIndex == 9 }"
                >EN</span
              >
            </router-link> -->
          </div>

          <!-- <div class="dropdown">
            <div class="menu bm">{{ $t("registration") }}</div>

            <div class="dropdown-content">
              <router-link to="/HyTicket"
                ><p>{{ $t("tickets") }}</p></router-link
              >

              <router-link to="/FreeTicket"
                ><p>{{ $t("free_tickets") }}</p></router-link
              >
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
export default {
  props: ["menuIndex"],
  created() {},
  data() {
    return {
      fileServerUrl: fileServerUrl,
      flag: true,
    };
  },
  methods: {
    changelang() {
      if (this.flag === true) {
        this.$i18n.locale = "en";
        this.flag = !this.flag;
      } else {
        this.$i18n.locale = "zh";
        this.flag = !this.flag;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import url('@/style/mobile/myHeader.scss');

div {
  font-family: PuHuiTi; //使用字体
}

.header {
  width: 100%;
  height: 40px;
  position: fixed;
  z-index: 999;
  top: 0;
  margin-bottom: 20px;
  background: white;
  // border-bottom: 2px solid rgb(31,163,209);
  //border: .1px solid red;
}

.dhl {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  //border-bottom: 2px solid #424cf9;

  //border: .1px solid red;
}

.dhl1 {
  width: 20%;
  height: 45%;
  margin-left: 10%;
  float: left;
  display: flex;
  align-items: flex-end;
  //border:1px solid red;
}

.dhl1 img {
  width: 62px;
  height: 13px;
}
.dhl2 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60%;
  height: 40%;
  //float: left;
  //border: .1px solid #02fff0;
  font-size: 12px;
  //flex-direction: row;
}
.dhl2 span {
  //font-weight: bold;
  font-size: 8px;
}
.dhl2 span:hover {
  color: rgb(31, 163, 209);
}

.menu {
  color: #585757;
}

.menu-active {
  color: rgb(31, 163, 209);
  font-weight: bold;
}

.dropdown {
  position: relative;

  display: inline-block;
}

.dropdown-content {
  display: none;

  position: absolute;

  background-color: #f9f9f9;

  min-width: 40px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

  padding: 12px 16px;

  margin-left: -25px;

  text-align: center;

  font-size: 0.1rem;
}

.dropdown:hover .dropdown-content {
  display: block;
}
p:hover {
  color: rgb(31, 163, 209);
}
p {
  color: black;
}
.dropdown-content1 {
  display: none;

  position: absolute;

  background-color: #f9f9f9;

  min-width: 35px;

  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

  padding: 12px 16px;

  margin-left: -10px;

  font-size: 5.9px;
}
.dropdown:hover .dropdown-content1 {
  display: block;
}
.iconEn {
  height: 100%;
  display: flex;
  align-items: flex-end;
  //font-weight: bold;
}

.bm {
  color: #ffffff;
  background-color: rgb(31, 163, 209);
  cursor: pointer;
  height: 15px;
  padding: 0 10px;
  // width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  margin-top: 3px;
  font-size: 0.1rem;
}

/* @media screen and (max-width: 767px){
         .dhl{
          margin-top: 10px;
         }
        }*/
</style>
